import styled from 'styled-components';
import { COLOR_BLACK } from '../../assets/styles/colors';

const PhoneVerificationRequiredSC = styled.div`
  .verification-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${COLOR_BLACK};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
  }

  .verification-content {
    background: white;
    padding: 50px;
    border-radius: 12px;
    max-width: 600px;
    width: 90%;
    text-align: center;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  }

  .verification-title {
    margin-bottom: 30px;
    color: #ff6600;
    font-size: 28px;
  }

  .verification-message {
    margin-bottom: 30px;
    line-height: 1.8;
    font-size: 18px;
    color: #333;
  }

  .verification-problems {
    margin-bottom: 0;
    line-height: 1.8;
    font-size: 16px;
    color: #666;
  }

  .login-link,
  .contact-link {
    color: #ff6600;
    text-decoration: none;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    display: inline;
    
    &:hover {
      text-decoration: underline;
    }
    
    &:focus {
      outline: 2px solid #ff6600;
      outline-offset: 2px;
    }
  }
`;

export default PhoneVerificationRequiredSC;

